import React from "react";

export function Introduction() {
  return (
    <div className="h-full flex flex-col items-center justify-center">
      <div className="max-w-2xl text-center space-y-6">
        <h1 className="text-3xl font-bold">Welcome to the Perceptual Crossing Experiment</h1>
        <p className="text-lg">
          In this experiment, you will interact with another participant in a one-dimensional virtual environment.
          You will first go through a tutorial to understand how the interaction works, and then participate in
          the main experiment.
        </p>
        <p className="text-lg">
          Your task will be to locate and maintain contact with the other participant.
        </p>
      </div>
    </div>
  );
} 